$(document).ready(function() {
    // Check if the current locale is 'fr'
    if (Shopify.locale === 'fr') {
  
        // Change the text to French
        setTimeout(function() {
        // Change the text to French after a 1-second delay
        $('.zooomypwishmsg').html('<i class="fa fa-heart-o"></i> Ajouter à la liste de souhaits');
    }, 1000); // 1000 milliseconds = 1 second
    }
});


(function (AOS, FlickityFade, scrollLock, Flickity, Sqrl, MicroModal, Rellax, themeCurrency, axios, FlickitySync, themeAddresses) {
// alert('21424123123123123123123123')
// Below are example event listeners.  They listen for theme events that Pipeline
// fires in order to make it easier for you to add customizations.

// Keep your scripts inside this IIFE function call to avoid leaking your


  document.addEventListener('theme:variant:change', function(event) {

    // alert('12111')
// You might use something like this to write a pre-order feature or a
// custom swatch feature.

    var variant = event.detail.variant;
    var container = event.target;

// console.log('Container ———————— ↓');
// console.log(container);
// console.log('Variant —————————— ↓');
// console.log(variant);
// ... update some element on the page
    const selectors = {
      groupImage: 'data-image-filter',
      slider: '[data-product-slideshow]',
      thumbSlider: '[data-product-thumbs]',
      thumbs: '[data-slideshow-thumbnail]',
      slides: '[data-media-slide]',
   

    };
    const slides = document.querySelectorAll(selectors.slides);
    const slider = document.querySelectorAll(selectors.slider);

    const selectors$9 = {
      groupImage: 'data-image-filter',
      slider: '[data-product-slideshow]',
      thumbSlider: '[data-product-thumbs]',
      thumbs: '[data-slideshow-thumbnail]',
      slides: '[data-media-slide]',
       flickityEnabled: 'flickity-enabled',
    };

    var currentLocale = Shopify.locale;
// console.log(currentLocale);
        var selectedRadio = document.querySelector('input[name="options[Colour]"]:checked');

   if(currentLocale == 'fr'){
     // alert('0.00')
         selectedRadio = document.querySelector('input[name="options[Couleur]"]:checked');
    // console.log(selectedRadio)
   }
    // console.log(selectedRadio)

// Get the value of the selected radio button
    var selectedValue = selectedRadio ? selectedRadio.value : null;
    var imageCode = selectedRadio.getAttribute('data-imagecode');

// co.le.log("Selected Colour:", selectedValue);
// Get all slides using the selector
// console.l.og('tessss')
    slides.forEach((slide) => {

// console.log(slide.dataset.imageFilter)

      const imgElement = slide.querySelector('img');
    
// Check if the img element exists and get its alt attribute
      var imgAlt = '';
      var imgSrc = '';
      if (imgElement) {
        
        imgSrc = imgElement.src;
          console.log(imgSrc)
        if (imgSrc.includes(imageCode)) {
          // alert('333333')
console.log(`The image source contains "${imageCode}".`);
        } else {
console.log(`The image source does not contain "${imageCode}".`);
        }
// console.log(imgAlt); // Logs the alt attribute value
      }
console.log(imageCode)
// Check for variantImageAlt (assuming it's defined elsewhere)
      if(imageCode != "null"){
      if (imgSrc.includes(imageCode)) {
        slide.classList.remove('hide'); // Assuming 'hide' is the hidden class
      } else {
 
        slide.classList.add('hide');
      }
      }
      else{
    

        slide.classList.remove('hide'); 
      }
      var slider = document.querySelector(selectors$9.slider);

         if (slider !== null) {
            // alert((slider.classList.contains(se.lectors.flickityEnable)))
           console.log(slider.classList);
           console.log(selectors$9.flickityEnabled)
        if (slider.classList.contains(selectors$9.flickityEnabled)) {
                     // alert('3333344444')

          const slider1 = FlickityFade.data(slider);
          if (typeof slider1 !== 'undefined') {
                       // alert('33000003')

            slider1.reloadCells();
          }
        }
      }
      
    });

  });

  document.addEventListener('theme:cart:change', function(event) {

     event.preventDefault();
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    let cartCountElement = document.querySelector('.drawer__top__left [data-header-cart-count]');
    // Select the button element using its class or any other selector
const button = document.querySelector('.btn--add-to-cart');

// Set a timeout to remove the classes after 1 second (1000 milliseconds)
setTimeout(() => {
  button.classList.remove('has-success1', 'has-success');
}, 1500);
    if (cartCountElement) {
        cartCountElement.innerHTML = cart.item_count;
    } else {
        console.error("Element not found.");
    }

    }
  });
// Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

// Debounced scroll listeners.  Up and down only fire on direction changes
// These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

// Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  function test(){
        // alert('12111')
// You might use something like this to write a pre-order feature or a
// custom swatch feature.

        // var variant = event.detail.variant;
        // var container = event.target;

// console.log('Container ———————— ↓');
// console.log(container);
// console.log('Variant —————————— ↓');
// console.log(variant);
// ... update some element on the page
        const selectors = {
            groupImage: 'data-image-filter',
            slider: '[data-product-slideshow]',
            thumbSlider: '[data-product-thumbs]',
            thumbs: '[data-slideshow-thumbnail]',
            slides: '[data-media-slide]',


        };
        const slides = document.querySelectorAll(selectors.slides);
        const slider = document.querySelectorAll(selectors.slider);

        const selectors$9 = {
            groupImage: 'data-image-filter',
            slider: '[data-product-slideshow]',
            thumbSlider: '[data-product-thumbs]',
            thumbs: '[data-slideshow-thumbnail]',
            slides: '[data-media-slide]',
            flickityEnabled: 'flickity-enabled',
        };

  
        var selectedRadio = document.querySelector('input[name="options[Colour]"]:checked');

// Get the value of the selected radio button
        var selectedValue = selectedRadio ? selectedRadio.value : null;
        var imageCode = selectedRadio.getAttribute('data-imagecode');
      console.log(imageCode);
      console.log(selectedValue)
// console.log("Selected Colour:", selectedValue);
// Get all slides using the selector
// console.log('tessss')
        slides.forEach((slide) => {

// console.log(slide.dataset.imageFilter)

            const imgElement = slide.querySelector('img');

// Check if the img element exists and get its alt attribute
            var imgAlt = '';
            var imgSrc = '';
            if (imgElement) {

                imgSrc = imgElement.src;
                console.log(imgSrc)
                if (imgSrc.includes(imageCode)) {
                    // alert('333333')
                    console.log(`The image source contains "${imageCode}".`);
                } else {
                    console.log(`The image source does not contain "${imageCode}".`);
                }
// console.log(imgAlt); // Logs the alt attribute value
            }
            console.log(imageCode)
// Check for variantImageAlt (assuming it's defined elsewhere)
            if(imageCode != "null"){
                if (imgSrc.includes(imageCode)) {
                    slide.classList.remove('hide'); // Assuming 'hide' is the hidden class
                } else {

                    slide.classList.add('hide');
                }
            }
            else{


                slide.classList.remove('hide');
            }
            var slider = document.querySelector(selectors$9.slider);

            if (slider !== null) {
                // alert((slider.classList.contains(se.lectors.flickityEnable)))
                console.log(slider.classList);
                console.log(selectors$9.flickityEnabled)
                if (slider.classList.contains(selectors$9.flickityEnabled)) {
                    // alert('3333344444')

                    const slider1 = FlickityFade.data(slider);
                    if (typeof slider1 !== 'undefined') {
                        // alert('33000003')

                        slider1.reloadCells();
                    }
                }
            }

        });
  }
  // alert($("#eclipse-in-store-gift-card").length)
  if ($("#eclipse-in-store-gift-card").length) {
     test();
} 


// Locks and unlocks page scroll for modals and drawers
// These are commented out because firing them will lock the page scroll
// the lock event must set `detail` to the modal or drawer body so the
// scroll locking code knows what element should maintain scoll.
// document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
// document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


// ^^ Keep your scripts inside this IIFE function call to avoid leaking your
// variables into the global scope.
})(themeVendor.AOS, themeVendor.FlickityFade, themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.Sqrl, themeVendor.MicroModal, themeVendor.Rellax, themeVendor.themeCurrency, themeVendor.axios, themeVendor.FlickitySync, themeVendor.themeAddresses);
